import { IComboBoxStyles, IDatePickerStyleProps, IDatePickerStyles, IStyleFunctionOrObject, ITextFieldStyleProps, ITextFieldStyles, IToggleStyleProps, IToggleStyles } from "@fluentui/react"

//#region TextField

export const textFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles> = {
    root: {
        width: '100%',
        borderRadius: '5px',
    },
    field: {
        fontFamily: 'Nunito',
        fontWeight: 500,
        width: '100%',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px',
    },
    fieldGroup: {
        border: '1px solid #000000',
        width: '100%',
        height: '4rem',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px'
    },
    wrapper: {
        borderRadius: '5px'
    },
    suffix:{
        backgroundColor: 'trasparent',
        border: 'none',
        borderRadius: '5px'
    }
}

export const xxlTextFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles> = {
    root: {
        width: '100%',
        borderRadius: '5px',
    },
    field: {
        fontFamily: 'Nunito',
        fontWeight: 500,
        width: '100%',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px',
    },
    fieldGroup: {
        border: '1px solid #000000',
        width: '100%',
        height: 'clamp(3.2rem, 2.5vw, 3.5rem)',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px'
    },
    wrapper: {
        borderRadius: '5px'
    },
    suffix:{
        backgroundColor: 'trasparent',
        border: 'none',
        borderRadius: '5px'
    }
}

export const xlTextFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles> = {
    root: {
        width: '100%',
        borderRadius: '5px',
    },
    field: {
        fontFamily: 'Nunito',
        fontWeight: 500,
        width: '100%',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px',
    },
    fieldGroup: {
        border: '1px solid #000000',
        width: '100%',
        height: 'clamp(3rem, 2.5vw, 3.2rem)',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px'
    },
    wrapper: {
        borderRadius: '5px'
    },
    suffix:{
        backgroundColor: 'trasparent',
        border: 'none',
        borderRadius: '5px'
    }
}

export const lgTextFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles> = {
    root: {
        width: '100%',
        borderRadius: '5px',
    },
    field: {
        fontFamily: 'Nunito',
        fontWeight: 500,
        width: '100%',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px',
    },
    fieldGroup: {
        border: '1px solid #000000',
        width: '100%',
        height: 'clamp(2.8rem, 2.5vw, 3rem)',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px'
    },
    wrapper: {
        borderRadius: '5px'
    },
    suffix:{
        backgroundColor: 'trasparent',
        border: 'none',
        borderRadius: '5px'
    }
}

export const mdTextFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles> = {
    root: {
        width: '100%',
        borderRadius: '5px',
    },
    field: {
        fontFamily: 'Nunito',
        fontWeight: 500,
        width: '100%',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px',
    },
    fieldGroup: {
        border: '1px solid #000000',
        width: '100%',
        height: 'clamp(2.5rem, 2.5vw, 2.8rem)',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px'
    },
    wrapper: {
        borderRadius: '5px'
    },
    suffix:{
        backgroundColor: 'trasparent',
        border: 'none',
        borderRadius: '5px'
    }
}

export const smTextFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles> = {
    root: {
        width: '100%',
        borderRadius: '5px',
    },
    field: {
        fontFamily: 'Nunito',
        fontWeight: 500,
        width: '100%',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px',
    },
    fieldGroup: {
        border: '1px solid #000000',
        width: '100%',
        height: 'clamp(2rem, 2.5vw, 2.5rem)',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px'
    },
    wrapper: {
        borderRadius: '5px'
    },
    suffix:{
        backgroundColor: 'trasparent',
        border: 'none',
        borderRadius: '5px'
    }
}

//#endregion TextField

//#region ComboBox

export const comboboxStyles: Partial<IComboBoxStyles> = {
    root: {
        width: '100%',
        height: '4rem',
        backgroundColor: '#F0F0F0',
        fontFamily: 'Nunito',
        fontWeight: 500,
        borderRadius: '5px',
        '::after': {
            borderRadius: '5px'
        }
    },
    input: {
        fontFamily: 'Nunito',
        fontWeight: 500,
        backgroundColor: '#F0F0F0',
        borderRadius: '5px',
        height: '4rem'
    },
    errorMessage: {
        fontFamily: 'Nunito',
        fontWeight: 400,
        textAlign: 'left',
        color: 'rgb(164, 38, 44)'
    }
}

export const xxlComboboxStyles: Partial<IComboBoxStyles> = {
    root: {
        width: '100%',
        height: 'clamp(3.2rem, 2.5vw, 3.5rem)',
        backgroundColor: '#F0F0F0',
        fontFamily: 'Nunito',
        fontWeight: 500,
        borderRadius: '5px',
        '::after': {
            borderRadius: '5px'
        }
    },
    input: {
        fontFamily: 'Nunito',
        fontWeight: 500,
        backgroundColor: '#F0F0F0',
        borderRadius: '5px',
        height: 'clamp(3.2rem, 2.5vw, 3.5rem)',
    },
    errorMessage: {
        fontFamily: 'Nunito',
        fontWeight: 400,
        textAlign: 'left',
        color: 'rgb(164, 38, 44)'
    }
}

export const xlComboboxStyles: Partial<IComboBoxStyles> = {
    root: {
        width: '100%',
        height: 'clamp(3rem, 2.5vw, 3.2rem)',
        backgroundColor: '#F0F0F0',
        fontFamily: 'Nunito',
        fontWeight: 500,
        borderRadius: '5px',
        '::after': {
            borderRadius: '5px'
        }
    },
    input: {
        fontFamily: 'Nunito',
        fontWeight: 500,
        backgroundColor: '#F0F0F0',
        borderRadius: '5px',
        height: 'clamp(3rem, 2.5vw, 3.2rem)',
    },
    errorMessage: {
        fontFamily: 'Nunito',
        fontWeight: 400,
        textAlign: 'left',
        color: 'rgb(164, 38, 44)'
    }
}

export const lgComboboxStyles: Partial<IComboBoxStyles> = {
    root: {
        width: '100%',
        height: 'clamp(2.8rem, 2.5vw, 3rem)',
        backgroundColor: '#F0F0F0',
        fontFamily: 'Nunito',
        fontWeight: 500,
        borderRadius: '5px',
        '::after': {
            borderRadius: '5px'
        }
    },
    input: {
        fontFamily: 'Nunito',
        fontWeight: 500,
        backgroundColor: '#F0F0F0',
        borderRadius: '5px',
        height: 'clamp(2.8rem, 2.5vw, 3rem)',
    },
    errorMessage: {
        fontFamily: 'Nunito',
        fontWeight: 400,
        textAlign: 'left',
        color: 'rgb(164, 38, 44)'
    }
}

export const mdComboboxStyles: Partial<IComboBoxStyles> = {
    root: {
        width: '100%',
        height: 'clamp(2.5rem, 2.5vw, 2.8rem)',
        backgroundColor: '#F0F0F0',
        fontFamily: 'Nunito',
        fontWeight: 500,
        borderRadius: '5px',
        '::after': {
            borderRadius: '5px'
        }
    },
    input: {
        fontFamily: 'Nunito',
        fontWeight: 500,
        backgroundColor: '#F0F0F0',
        borderRadius: '5px',
        height: 'clamp(2.5rem, 2.5vw, 2.8rem)',
    },
    errorMessage: {
        fontFamily: 'Nunito',
        fontWeight: 400,
        textAlign: 'left',
        color: 'rgb(164, 38, 44)'
    }
}

export const smComboboxStyles: Partial<IComboBoxStyles> = {
    root: {
        width: '100%',
        height: 'clamp(2rem, 2.5vw, 2.5rem)',
        backgroundColor: '#F0F0F0',
        fontFamily: 'Nunito',
        fontWeight: 500,
        borderRadius: '5px',
        '::after': {
            borderRadius: '5px'
        }
    },
    input: {
        fontFamily: 'Nunito',
        fontWeight: 500,
        backgroundColor: '#F0F0F0',
        borderRadius: '5px',
        height: 'clamp(2rem, 2.5vw, 2.5rem)',
    },
    errorMessage: {
        fontFamily: 'Nunito',
        fontWeight: 400,
        textAlign: 'left',
        color: 'rgb(164, 38, 44)'
    }
}

//#endregion ComboBox

//#region DatePicker

export const datePickerStyles: IStyleFunctionOrObject<IDatePickerStyleProps, IDatePickerStyles> = {
    root: {
        width: '100%',
        height: '4rem',
        fontFamily: 'Nunito',
        fontWeight: 500,
        borderRadius: '5px'
    },
    wrapper: {
        width: '100%',
        height: '4rem',
    },
    textField: {
        width: '100%',
        height: '4rem',
        fontFamily: 'Nunito',
        fontWeight: 500,
        borderRadius: '5px'
    },
    readOnlyTextField: {
        width: '100%',
        height: '4rem',
        fontFamily: 'Nunito',
        fontWeight: 500,
        backgroundColor: '#F0F0F0',
        padding: '0.5dvw',
        display: 'flex',
        justifyItems: 'center',
        alignItems: 'center',
    }
}

export const xxlDatePickerStyles: IStyleFunctionOrObject<IDatePickerStyleProps, IDatePickerStyles> = {
    root: {
        width: '100%',
        height: 'clamp(3.2rem, 2.5vw, 3.5rem)',
        fontFamily: 'Nunito',
        fontWeight: 500,
        borderRadius: '5px'
    },
    wrapper: {
        width: '100%',
        height: 'clamp(3.2rem, 2.5vw, 3.5rem)',
    },
    textField: {
        width: '100%',
        height: 'clamp(3.2rem, 2.5vw, 3.5rem)',
        fontFamily: 'Nunito',
        fontWeight: 500,
        borderRadius: '5px'
    },
    readOnlyTextField: {
        width: '100%',
        height: 'clamp(3.2rem, 2.5vw, 3.5rem)',
        fontFamily: 'Nunito',
        fontWeight: 500,
        backgroundColor: '#F0F0F0',
        padding: '0.5dvw',
        display: 'flex',
        justifyItems: 'center',
        alignItems: 'center',
    }
}

export const xlDatePickerStyles: IStyleFunctionOrObject<IDatePickerStyleProps, IDatePickerStyles> = {
    root: {
        width: '100%',
        height: 'clamp(3rem, 2.5vw, 3.2rem)',
        fontFamily: 'Nunito',
        fontWeight: 500,
        borderRadius: '5px'
    },
    wrapper: {
        width: '100%',
        height: 'clamp(3rem, 2.5vw, 3.2rem)',
    },
    textField: {
        width: '100%',
        height: 'clamp(3rem, 2.5vw, 3.2rem)',
        fontFamily: 'Nunito',
        fontWeight: 500,
        borderRadius: '5px'
    },
    readOnlyTextField: {
        width: '100%',
        height: 'clamp(3rem, 2.5vw, 3.2rem)',
        fontFamily: 'Nunito',
        fontWeight: 500,
        backgroundColor: '#F0F0F0',
        padding: '0.5dvw',
        display: 'flex',
        justifyItems: 'center',
        alignItems: 'center',
    }
}

export const lgDatePickerStyles: IStyleFunctionOrObject<IDatePickerStyleProps, IDatePickerStyles> = {
    root: {
        width: '100%',
        height: 'clamp(2.8rem, 2.5vw, 3rem)',
        fontFamily: 'Nunito',
        fontWeight: 500,
        borderRadius: '5px'
    },
    wrapper: {
        width: '100%',
        height: 'clamp(2.8rem, 2.5vw, 3rem)',
    },
    textField: {
        width: '100%',
        height: 'clamp(2.8rem, 2.5vw, 3rem)',
        fontFamily: 'Nunito',
        fontWeight: 500,
        borderRadius: '5px'
    },
    readOnlyTextField: {
        width: '100%',
        height: 'clamp(2.8rem, 2.5vw, 3rem)',
        fontFamily: 'Nunito',
        fontWeight: 500,
        backgroundColor: '#F0F0F0',
        padding: '0.5dvw',
        display: 'flex',
        justifyItems: 'center',
        alignItems: 'center',
    }
}

export const mdDatePickerStyles: IStyleFunctionOrObject<IDatePickerStyleProps, IDatePickerStyles> = {
    root: {
        width: '100%',
        height: 'clamp(2.5rem, 2.5vw, 2.8rem)',
        fontFamily: 'Nunito',
        fontWeight: 500,
        borderRadius: '5px'
    },
    wrapper: {
        width: '100%',
        height: 'clamp(2.5rem, 2.5vw, 2.8rem)',
    },
    textField: {
        width: '100%',
        height: 'clamp(2.5rem, 2.5vw, 2.8rem)',
        fontFamily: 'Nunito',
        fontWeight: 500,
        borderRadius: '5px'
    },
    readOnlyTextField: {
        width: '100%',
        height: 'clamp(2.5rem, 2.5vw, 2.8rem)',
        fontFamily: 'Nunito',
        fontWeight: 500,
        backgroundColor: '#F0F0F0',
        padding: '0.5dvw',
        display: 'flex',
        justifyItems: 'center',
        alignItems: 'center',
    }
}

export const smDatePickerStyles: IStyleFunctionOrObject<IDatePickerStyleProps, IDatePickerStyles> = {
    root: {
        width: '100%',
        height: 'clamp(2rem, 2.5vw, 2.5rem)',
        fontFamily: 'Nunito',
        fontWeight: 500,
        borderRadius: '5px'
    },
    wrapper: {
        width: '100%',
        height: 'clamp(2rem, 2.5vw, 2.5rem)',
    },
    textField: {
        width: '100%',
        height: 'clamp(2rem, 2.5vw, 2.5rem)',
        fontFamily: 'Nunito',
        fontWeight: 500,
        borderRadius: '5px'
    },
    readOnlyTextField: {
        width: '100%',
        height: 'clamp(2rem, 2.5vw, 2.5rem)',
        fontFamily: 'Nunito',
        fontWeight: 500,
        backgroundColor: '#F0F0F0',
        padding: '0.5dvw',
        display: 'flex',
        justifyItems: 'center',
        alignItems: 'center',
    }
}

export const datePickertextFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles> = {
    root: {
        width: '100%',
        borderRadius: '5px'
    },
    field: {
        fontFamily: 'Nunito',
        fontWeight: 500,
        width: '100%',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px',
        border: '1px solid black'
    },
    fieldGroup: {
        width: '100%',
        height: '4rem',
        backgroundColor: '#F0F0F0',
        justifyContent: 'center',
        justifyItems: 'center',
        alignItems: 'center',
        borderRadius: '5px'
    }
}

export const xxlDatePickerTextFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles> = {
    root: {
        width: '100%'
    },
    field: {
        fontFamily: 'Nunito',
        fontWeight: 500,
        width: '100%',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px',
        border: '1px solid black'
    },
    fieldGroup: {
        width: '100%',
        height: 'clamp(3.2rem, 2.5vw, 3.5rem)',
        backgroundColor: '#F0F0F0',
        justifyContent: 'center',
        justifyItems: 'center',
        alignItems: 'center',
    }
}

export const xlDatePickerTextFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles> = {
    root: {
        width: '100%'
    },
    field: {
        fontFamily: 'Nunito',
        fontWeight: 500,
        width: '100%',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px',
        border: '1px solid black'
    },
    fieldGroup: {
        width: '100%',
        height: 'clamp(3rem, 2.5vw, 3.2rem)',
        backgroundColor: '#F0F0F0',
        justifyContent: 'center',
        justifyItems: 'center',
        alignItems: 'center',
    }
}

export const lgDatePickerTextFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles> = {
    root: {
        width: '100%'
    },
    field: {
        fontFamily: 'Nunito',
        fontWeight: 500,
        width: '100%',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px',
        border: '1px solid black'
    },
    fieldGroup: {
        width: '100%',
        height: 'clamp(2.8rem, 2.5vw, 3rem)',
        backgroundColor: '#F0F0F0',
        justifyContent: 'center',
        justifyItems: 'center',
        alignItems: 'center',
    }
}

export const mdDatePickerTextFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles> = {
    root: {
        width: '100%'
    },
    field: {
        fontFamily: 'Nunito',
        fontWeight: 500,
        width: '100%',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px',
        border: '1px solid black'
    },
    fieldGroup: {
        width: '100%',
        height: 'clamp(2.5rem, 2.5vw, 2.8rem)',
        backgroundColor: '#F0F0F0',
        justifyContent: 'center',
        justifyItems: 'center',
        alignItems: 'center',
    }
}

export const smDatePickerTextFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles> = {
    root: {
        width: '100%'
    },
    field: {
        fontFamily: 'Nunito',
        fontWeight: 500,
        width: '100%',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px',
        border: '1px solid black'
    },
    fieldGroup: {
        width: '100%',
        height: 'clamp(2rem, 2.5vw, 2.5rem)',
        backgroundColor: '#F0F0F0',
        justifyContent: 'center',
        justifyItems: 'center',
        alignItems: 'center',
    }
}

//#endregion DatePicker

//#region Flag

export const flagStyles: IStyleFunctionOrObject<IToggleStyleProps, IToggleStyles> = {
    label: {
        fontFamily: 'Nunito',
        fontWeight: 500,
        color: '#323130',
        fontSize: '1.2rem'
    }
}

export const xxlFlagStyles: IStyleFunctionOrObject<IToggleStyleProps, IToggleStyles> = {
    label: {
        fontFamily: 'Nunito',
        fontWeight: 500,
        color: '#323130',
        fontSize: 'clamp(1.1rem, 2.5vw, 1.2rem)'
    }
}

export const xlFlagStyles: IStyleFunctionOrObject<IToggleStyleProps, IToggleStyles> = {
    label: {
        fontFamily: 'Nunito',
        fontWeight: 400,
        color: '#323130',
        fontSize: 'clamp(1rem, 2.5vw, 1.1rem)'
    }
}

export const lgFlagStyles: IStyleFunctionOrObject<IToggleStyleProps, IToggleStyles> = {
    label: {
        fontFamily: 'Nunito',
        fontWeight: 400,
        color: '#323130',
        fontSize: 'clamp(0.95rem, 2.5vw, 1rem)'
    }
}

export const mdFlagStyles: IStyleFunctionOrObject<IToggleStyleProps, IToggleStyles> = {
    label: {
        fontFamily: 'Nunito',
        fontWeight: 400,
        color: '#323130',
        fontSize: 'clamp(0.9rem, 2.5vw, 0.95rem)'
    }
}

export const smFlagStyles: IStyleFunctionOrObject<IToggleStyleProps, IToggleStyles> = {
    label: {
        fontFamily: 'Nunito',
        fontWeight: 400,
        color: '#323130',
        fontSize: 'clamp(0.85rem, 2.5vw, 0.9rem)'
    }
}

//#endregion Flag